import IProfissao from '../../interfaces/IProfissao';
import IProfissaoParaSelect from '../../interfaces/IProfissaoParaSelect';

export const mapearProfissoesParaSelect = (profissoes: IProfissao[]): IProfissaoParaSelect[] =>
  profissoes.map(({ id, nome, ehSegurancaPublica }) => ({
    value: id,
    label: nome,
    ehSegurancaPublica
  }));